import { render, staticRenderFns } from "./PerformanceCrowdSelection.vue?vue&type=template&id=483b47fe&"
import script from "./PerformanceCrowdSelection.vue?vue&type=script&lang=js&"
export * from "./PerformanceCrowdSelection.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceCrowdSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports